export default __webpack_public_path__ + "static/media/talent_search_tile.a0c42aec.jpg";